module.exports = __webpack_public_path__ + "static/img/奔驰G-wagen.7445264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/奔驰G-wagen.jpg
// module id = fT17
// module chunks = 1